module.exports = __webpack_public_path__ + "img/wallace-logo.13841ec4.jpg";